import BaseApi from './baseApi';
import ICustomerAdresses from '../models/ICustomerAdresses';
import IAuthentication from '../models/IAuthentication';
export default class CustomerAdressesApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Customers");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetCustomerAdresses(customerId: string) : Promise<ICustomerAdresses[]> {
        const json = this.getJsonRead(customerId);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var customerAdresses: ICustomerAdresses[] = [];
            customerAdresses = response.data as ICustomerAdresses[];
            return customerAdresses;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveCustomerAdres(customerAdress: ICustomerAdresses) : Promise<string> {
        const json = this.getJsonSave(customerAdress);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateCustomerAdres(customerAdress: ICustomerAdresses) : Promise<boolean> {
        const json = this.getJsonUpdate(customerAdress);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteCustomerAdres(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "CustomersAdresses",
            "conditions": [{
                "Item1": "CustomersAdresses",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(customerAdress: ICustomerAdresses) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "street",
                "Item2": customerAdress.street
            }, {
                "Item1": "Number",
                "Item2": customerAdress.number
            }, {
                "Item1": "City",
                "Item2": customerAdress.city
            }, {
                "Item1": "ZipCode",
                "Item2": customerAdress.zipCode
            }, {
                "Item1": "IdListCountry",
                "Item2": customerAdress.idListCountry
            }, {
                "Item1": "IdCustomer",
                "Item2": customerAdress.idCustomer
            }, {
                "Item1": "IdListAdressType",
                "Item2": customerAdress.idListAdressType
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "CustomersAdresses"
        };
        return json;
    }

    private getJsonUpdate(customerAdress: ICustomerAdresses) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "street",
                "Item2": customerAdress.street
            }, {
                "Item1": "Number",
                "Item2": customerAdress.number
            }, {
                "Item1": "City",
                "Item2": customerAdress.city
            }, {
                "Item1": "ZipCode",
                "Item2": customerAdress.zipCode
            }, {
                "Item1": "IdListCountry",
                "Item2": customerAdress.idListCountry
            }, {
                "Item1": "IdCustomer",
                "Item2": customerAdress.idCustomer
            }, {
                "Item1": "IdListAdressType",
                "Item2": customerAdress.idListAdressType
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "CustomerAdresses",
            "keyvalue": customerAdress.id
        };
        return json;
    }

    private getJsonRead(customerId: string) : any {
        const json = {
            "fields": [{
                "Item1": "CustomersAdresses",
                "Item2": "id"
            }, {
                "Item1": "CustomersAdresses",
                "Item2": "street"
            }, {
                "Item1": "CustomersAdresses",
                "Item2": "number"
            }, {
                "Item1": "CustomersAdresses",
                "Item2": "city"
            }, {
                "Item1": "CustomersAdresses",
                "Item2": "zipCode"
            }, {
                "Item1": "CustomersAdresses",
                "Item2": "idListCountry"
            }, {
                "Item1": "ListCountries",
                "Item2": "countryName"
            }, {
                "Item1": "ListCountries",
                "Item2": "code"
            }, {
                "Item1": "CustomersAdresses",
                "Item2": "idCustomer"
            }, {
                "Item1": "CustomersAdresses",
                "Item2": "idListAdressType"
            }, {
                "Item1": "ListAdressTypes",
                "Item2": "typeName"
            }],
            "tables": [{
                "Item1": "CustomersAdresses"
            }, {
                "Item1": "ListCountries"
            }, {
                "Item1": "ListAdressTypes"
            }],
            "joins": [{
                "Item1": "CustomersAdresses",
                "Item2": "IdListCountry",
                "Item3": "ListCountries",
                "Item4": "Id"
            }, {
                "Item1": "CustomersAdresses",
                "Item2": "IdListAdressType",
                "Item3": "ListAdressTypes",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "CustomersAdresses",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "CustomersAdresses",
                "Item2": "IdCustomer",
                "Item3": "=",
                "Item4": customerId
            }]
        };
        return json;
    }
}
